export default __webpack_public_path__ + "static/media/dj-hero.0860f64d.png";